import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function leftArrow({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="black"
      viewBox="0 0 14 15"
      width="14"
      height="15"
      className={className}
    >
      <path
        stroke="none"
        d="M.5 8.366a1 1 0 010-1.732L11.75.139a1 1 0 011.5.866v12.99a1 1 0 01-1.5.866L.5 8.366z"
      />
    </svg>
  );
}

export default leftArrow;
